module.exports = __webpack_public_path__ + "media/components/riskregister/icons/reputation-b0f2def611dd9def55e61421fae4822d.png";